import React, { memo } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { useStaticContext, selectRecipientInfo } from '../../context/contexts/static';
import { getResponseTimeTextValue } from '../../../utils/time';

import classes from './style.module.scss';

const ResponseTime = ({ className, showOnlineStatus = true }) => {
    const context = useStaticContext();
    const { isOnline, responseTimeInHrs } = selectRecipientInfo(context);
    const responseTime = getResponseTimeTextValue(responseTimeInHrs);

    const key = isOnline ? 'online' : 'offline';

    return (
        <span className={classNames(className, classes.sellerResponseTime)} data-testid="response-time-container">
            {showOnlineStatus && <I18n k={`send_message.user.${key}`}/>}
            {!isEmpty(responseTime) && (
                <>
                    {showOnlineStatus && <span className={classNames(classes.separationEllipse, 'flex bg-co-grey-1000')}/>}
                    <I18n k="send_message.time.avg_response_time"
                        params={{ responseTime }}
                        templates={{
                            time: (text) => (
                                <span data-testid="response-time" className="text-semi-bold m-l-4">
                                    {text}
                                </span>
                            )
                        }}/>
                </>
            )}
        </span>
    );
};

ResponseTime.propTypes = {
    className: PropTypes.string,
    showOnlineStatus: PropTypes.bool
};

export default memo(ResponseTime);
